// extracted by mini-css-extract-plugin
module.exports = {"article":"articles_article__cXD_2","article_title":"articles_article_title__m_Mps","grey_background":"articles_grey_background__ZYqIq"};